import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPrinter: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="printer, print"><path d="M17.25 2.75H6.75V6.75H17.25V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M6.75 21.25H17.25V13.75H6.75V21.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M21.25 6.75H2.75V17.25H6.75V13.75H17.25V17.25H21.25V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M9.25 10.75H6.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPrinter;
